"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityProgress = void 0;
const core_1 = require("@angular/core");
const enums_1 = require("../../../@shared-types/opportunites/enums");
let OpportunityProgress = class OpportunityProgress {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_a = typeof enums_1.EOpportunityProgress !== "undefined" && enums_1.EOpportunityProgress) === "function" ? _a : Object)
], OpportunityProgress.prototype, "progress", void 0);
OpportunityProgress = __decorate([
    (0, core_1.Component)({
        selector: 'opportunity-progress',
        template: `
    <ng-container [ngSwitch]="progress">
      <tag *ngSwitchCase="'R'" text="Reservierung" color="orange"></tag>

      <tag *ngSwitchCase="'S'" text="Verkauf" color="red"></tag>

      <tag *ngSwitchCase="'C'" text="Kaufvertrag" color="red"></tag>

      <tag *ngSwitchCase="'O'" text="Angebot" color="green"></tag>

      <tag *ngSwitchCase="'X'" text="Erstellt" color="blue"></tag>
    </ng-container>
  `,
    })
], OpportunityProgress);
exports.OpportunityProgress = OpportunityProgress;
